<template>
  <el-dialog title="关联知识点选择"
             append-to-body
             :visible.sync="dialogVisible"
             width="1060px"
             @close="close()"
             @open="open()">
    <div class="dialog">
      <el-form :inline="true"
               :model="formInline"
               class="demo-form-inline">
        <el-form-item label="ID">
          <el-input style="width: 138px"
                    v-model="query.id"
                    placeholder="商品ID"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="名称">
          <el-input style="width: 138px"
                    v-model="query.name"
                    placeholder="请输入商品名称"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="资料分类">
          <el-select style="width: 138px"
                     v-model="query.category_id"
                     placeholder="请选择"
                     clearable>
            <el-option v-for="item in $store.state.readCategorys"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="状态"
                      prop="status">
          <el-select v-model="query.status"
                     placeholder="请选择"
                     clearable>
            <el-option v-for="item in filter.status"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary"
                     @click="inquire">查询</el-button>
          <el-button @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <el-empty description="数据为空"
                v-if="!dataList.length"></el-empty>
      <table v-loading="table_loading">
        <tbody v-for="(item, index) in dataList"
               :key="index">
          <tr v-if="index == 0">
            <th style="width: 45px"></th>
            <th>ID</th>
            <th>商品图</th>
            <th style="width: 200px">名称</th>
            <th>资料分类</th>
            <th>关联科目</th>
            <th>售价</th>
            <th>创建时间</th>
            <th>状态</th>
          </tr>
          <tr>
            <td>
              <i class="el-icon-caret-bottom"
                 style="color: #c0c4cc"
                 v-if="item.flag"></i>
              <i class="el-icon-caret-right"
                 style="color: #c0c4cc"
                 v-else></i>
              <el-checkbox @change="fetchReadChapterList(item, index)"
                           v-model="item.flag"
                           style="margin-left: 4px"></el-checkbox>
            </td>
            <td>{{ item.id }}</td>
            <td>
              <el-image style="height: 50px"
                        :src="item.picture_url"
                        fit="fill"></el-image>
            </td>
            <td>
              <el-tooltip class="item"
                          effect="dark"
                          :content="item.name"
                          placement="top">
                <div class="ellipsis">{{ item.name }}</div>
              </el-tooltip>
            </td>

            <td>
              {{ formateCategory_id(item.category_id) }}
            </td>
            <td>
              {{ formatSubject(item.subjects) }}
            </td>
            <td>
              <span v-if="item.price > 0">{{ item.price + "元" }}</span>
              <span v-else>免费</span>
            </td>
            <td>
              {{ $moment(item.create_time).format("YYYY.MM.DD") }}
            </td>
            <td>
              <el-tag size="small"
                      :type="item.status == 1 ? 'success' : 'danger'">{{ item.status == 1 ? "上架" : "下架" }}</el-tag>
            </td>
          </tr>

          <tr v-if="item.flag">
            <td colspan="9"
                style="padding: 0">
              <table v-loading="loading">
                <SpecialRecursiveComponent :nodes="item"
                                           @childSubmit="childSubmit"
                                           @cancleFlag='cancleFlag'
                                           @SkipProgress="SkipProgress" />
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="footer">
      <el-pagination background
                     layout="total, prev, pager, next, sizes, jumper"
                     :current-page="Number(query.pageIndex)"
                     :page-sizes="[10, 20, 50, 100, 500]"
                     :page-size="Number(query.pageSize)"
                     :total="Number(pageTotal)"
                     @size-change="handleSizeChange"
                     @current-change="handlePageChange"></el-pagination>
      <el-button type="primary"
                 @click="submit">确 定</el-button>
    </div>
    <!-- <span slot="footer" class="dialog-footer">
         
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span> -->
  </el-dialog>
</template>

<script>
import {
  readList,
  readChapterList,
  refCreateChapterLevel2,
  copyCreateChapterLevel2,
  readPaperItemList,
} from '@/api/read'
import { examItemUpdate, KnowledgeDetail } from '@/api/exam'

import SpecialRecursiveComponent from '../../components/exam/SpecialRecursiveComponent.vue'
export default {
  components: { SpecialRecursiveComponent },
  data() {
    return {
      checkItems: {},
      dialogVisible: false,
      id: '',
      create_type: 0,
      formInline: {},
      checked1: true,
      loading: false,
      table_loading: false,
      query: {
        sort: '1',
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1,
      },
      pageTotal: 0,
      filter: {
        status: [
          { label: '全部', value: '' },
          { label: '上架', value: '1' },
          { label: '下架', value: '0' },
          { label: '待审核', value: '2' },
        ],
      },
      dataList: [
        // {
        //   name: "1",
        //   level: 0,
        //   child: [
        //     {
        //       level: 1,
        //       name: "1-1",
        //       child: [
        //         {
        //           level: 2,
        //           name: "1-1-1",
        //         },
        //         {
        //           level: 2,
        //           name: "1-1-1",
        //         },
        //       ],
        //     },
        //     {
        //       level: 1,
        //       name: "1-2",
        //       child: [
        //         {
        //           level: 2,
        //           name: "1-2-1",
        //         },
        //         {
        //           level: 2,
        //           name: "1-2-2",
        //         },
        //       ],
        //     },
        //   ],
        // },
        // {},
        // {},
      ],
      dataListChild: [],
      childItem: {},
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    content: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
  },
  methods: {
    inquire() {
      this.fetchReadList(true)
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    reset() {
      this.query = {
        sort: '1',
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1,
      }
      this.fetchReadList()
    },

    retractionExpansion(row, index) {},

    open(id, create_type) {
      this.id = id
      this.create_type = create_type
      this.$store.dispatch('getReadCategorys')
      this.fetchReadList(true)
      this.dialogVisible = true
    },

    fetchReadList(isReset = false) {
      this.table_loading = true
      if (isReset) {
        this.$set(this.query, 'pageIndex', 1)
      }
      let params = { ...this.query }
      this.dataList = []
      readList(params).then((res) => {
        this.table_loading = false
        this.dataList = res.list || []

        this.pageTotal = res.count
      })
    },

    clearList(node, id) {
      let list = [...node]
      list.map((e) => {
        if (e.id !== id) {
          e.flag = false
          if (e.children && e.children.length) {
            return this.clearList(e.children)
          }
        }
      })
      return list
    },

    fetchReadChapterList(item, index) {
      this.clearList(this.dataList, item.id)
      if (item.flag) {
        this.loading = true
        readChapterList({ product_id: item.id }).then((res) => {
          let list = res.list || []
          list.forEach((item) => (item.lev = 1))
          this.$set(this.dataList[index], 'children', list)
          this.loading = false
        })
      }
    },
    cancleFlag(item) {
      this.dataList.map((e) => {
        if (e.id == item.product_id) {
          e.children.map((el) => {
            if (el.id != item.id) {
              el.flag = false
            }
          })
        }
      })
    },
    SkipProgress(item) {
      this.dataList.map((e) => {
        if (e.id == item.product_id) {
          e.children.map((el) => {
            if (el.id == item.pid) {
              el.children.map((n) => {
                if (n.id != item.id) {
                  n.flag = false
                }
              })
            }
          })
        }
      })
    },
    childSubmit(val, parent) {
      let date
      this.dataList.map((e) => {
        if (e.id == parent.product_id) {
          e.children.map((el) => {
            if (el.id == parent.pid) {
              el.children.map((n) => {
                if (n.id == parent.id) {
                  n.children.map((ls) => {
                    if (ls.id != val.id) {
                      ls.flag = false
                    } else {
                      date = ls
                    }
                  })
                }
              })
            }
          })
        }
      })
      this.checkItems = date
    },
    submit() {
      examItemUpdate({
        ref_read_item_id: this.checkItems.item_id,
        id: this.content.item_id,
      }).then((res) => {
        if (res.ref_read_item_id != null) {
          this.$message.success('关联成功！')
          let data = {
            item_ids_str: res.ref_read_item_id,
          }
          KnowledgeDetail(data).then((res) => {
            this.$emit('readName', res.list[0].item_chapter_name)
            // console.log('res.list[0].resource.name', res.list[0].resource.name)
          })
          this.dialogVisible = false
          // this.$forceUpdate()
        }
        // console.log('res2222', res)
      })

      // let list = this.dataList
      //   .filter((item) => item.flag && item.children.length)
      //   .map((its) => its.children)
      //   .flat()
      // let pitchList = list
      //   .filter((item) => item.flag && item.children.length)
      //   .map((its) => its.children)
      //   .flat()
      // let ids = pitchList.filter((item) => item.flag).map((its) => its.id)
      // if (!ids.length) {
      //   this.$message.error('请选择章节')
      //   return
      // }
      // if (this.create_type == 2) {
      //   refCreateChapterLevel2({
      //     target_read_chapter_level_1_id: this.id,
      //     arr_source_read_chapter_level_2_id: ids,
      //   }).then((res) => {
      //     this.$emit('submit')
      //     this.dialogVisible = false
      //     this.$message.success('关联成功！')
      //   })
      // } else if (this.create_type == 3) {
      //   copyCreateChapterLevel2({
      //     target_read_chapter_level_1_id: this.id,
      //     arr_source_read_chapter_level_2_id: ids,
      //   }).then((res) => {
      //     this.$emit('submit')
      //     this.dialogVisible = false
      //     this.$message.success('复制成功！')
      //   })
      // }
    },

    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      this.fetchReadList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchReadList()
    },

    formateCategory_id(id) {
      if (
        this.$store.state.readCategorys &&
        this.$store.state.readCategorys.length
      ) {
        if (id) {
          return this.$store.state.readCategorys.find((v) => {
            return v.id == id
          }).name
        } else {
          return '无'
        }
      }
    },

    formatSubject(array) {
      if (array.length) {
        return array
          .map((v) => {
            return v.name
          })
          .join(',')
      } else {
        return '无'
      }
    },
  },
}
</script>


<style lang="less" scoped>
.dialog {
  min-height: 800px;
}
table {
  border-collapse: collapse;
  width: 100%;
  table-layout: fixed;
}

th,
td {
  padding: 8px;
  text-align: center;
  vertical-align: middle;
}
th {
  background: #ebeef5;
}
tr {
  border-bottom: 1px solid #ebeef5;
}

.ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.footer {
  margin-top: 24px;
  display: flex;
  justify-content: space-between;
}
</style>
